// utils
import Image from 'next/image';
import { useEffect, useState } from 'react';
import DrawerComponent from '../../drawer/DrawerComponent';
import HistoryComponent from '../../history/HistoryComponent';
import Topo from '../topo/Topo';
import TopoRegioes from '../topo-regioes/TopoRegioes';
import Topo2 from '../topo2/Topo';
import { NEW_TOPO } from '../../registry/home';
import { topoDaHomeNasInternas } from '../../../utils/topoHomeNasInternas';
import { paginaInternaAtelier } from '../atelier/atelier';
import { ehModeloAurora } from '../aurora/aurora';
import { ehModeloHorizonte } from '../horizonte/horizonte';
import { ehModeloLarissa } from '../larissa/larissa';
import { ehModeloMetropole } from '../metropole/metropole';
import { ehModeloInternacional } from '../internacional/internacional';
import { ehModeloPanorama } from '../panorama/panorama';
import styles from './WelcomePiecesCompany.module.css';

const WelcomePiecesCompany: React.FC<{
    site: any;
    activeDrawer: any;
    setActiveDrawer: any;
    titulo?: string;
    routes?: any;
    bannerListagem?: any;
    favorito: Array<number>;
    props: any;
    // segmento da URL → rótulo do breadcrumb (rotulosHifen, gate utils/hifenUrl)
    rotulos?: Record<string, string>;
}> = ({ site, activeDrawer, setActiveDrawer, titulo, routes, favorito, bannerListagem, props, rotulos }) => {
    // REGISTRY: variante nova de topo ANTES do ternário legado — mesmo mapa da
    // home (chave = modelo_topo). Sem entrada ⇒ undefined ⇒ topo de sempre
    // (diff nulo nos ~300 sites). Sem este ponto, o topo novo só apareceria na home.
    // cs2586: opção "topo da home nas internas" (topos 5/6/7) — ver utils/topoHomeNasInternas.
    const TopoNovo = NEW_TOPO[Number(site?.modelo_topo)] ?? topoDaHomeNasInternas(site);
    // #794 cs2586: o tenant pediu pra ELIMINAR o espaço do topo na listagem
    // ("Como eliminar este espaço?"). Na allowlist SEM_HERO_LISTAGEM a listagem
    // sai sem o hero (header encolhe pra faixa do menu, header_compact) e sem o
    // banner padrão de fallback. Allowlist pra não mudar os ~300 sites (padrão
    // logoTenant); fora dela NADA muda. Reversível: tirar o id volta o hero.
    const SEM_HERO_LISTAGEM = new Set([2586]);
    const semHero = SEM_HERO_LISTAGEM.has(Number(site?.id));
    // Atelier (topo 12): sem banner de listagem no CRM, a página abre direto no título editorial em
    // papel, como a home do modelo — o banner-padrão (a piscina) não entra. Banner configurado segue.
    // Internacional (topo 16): idem — a listagem da referência abre no título grande, sem foto genérica (a piscina).
    // Metrópole (topo 15): idem — a listagem da referência abre na página branca com o título, sem foto genérica, e o
    // modelo não tem foto própria em public/ (como o Larissa tem): o padrão é NÃO ter banner (o CSS recolhe a faixa
    // cinza pelo data-welcome). Banner configurado no CRM segue valendo, sem o escurecimento do legado.
    // Norte (topo 17): idem — as internas abrem no título (faixa do modelo), sem a foto genérica do banner.
    const metropole = ehModeloMetropole(site);
    // Campo (topo 18): idem — as internas abrem no título (faixa de papel do modelo), sem a foto genérica do banner.
    const semBannerPadrao = paginaInternaAtelier(site) || metropole || ehModeloInternacional(site) || Number(site?.modelo_topo) === 17 || Number(site?.modelo_topo) === 18;
    // Aurora (topo 10): sem banner de listagem no CRM, o padrão é a foto do modelo (casa moderna ao
    // entardecer, public/aurora) no lugar da piscina — Daniel 14/10. Banner configurado segue valendo.
    // Daniel 15/10: o mesmo para Horizonte (topo 11, varanda de frente para o mar), Panorama (topo 13,
    // cidade vista do alto) e Larissa (topo 14, casa com jardim tropical) — fotos geradas por IA, sem marca.
    const bannerPadrao = ehModeloAurora(site)
        ? '/aurora/imoveis-banner.jpg'
        : ehModeloHorizonte(site)
          ? '/horizonte/imoveis-banner.jpg'
          : ehModeloPanorama(site)
            ? '/panorama/imoveis-banner.jpg'
            : ehModeloLarissa(site)
              ? '/larissa/imoveis-banner.jpg'
              : 'https://fotos.sobressai.com.br/Banner/1722/10526.jpg';
    const urlBanner = semHero
        ? null
        : (bannerListagem ? bannerListagem?.url : semBannerPadrao ? null : bannerPadrao);
    const topoCompacto = semHero;
    // cs2639 CASAMAIS+ (21/09/2026): o banner de listagem é branco e o `filter: brightness(0.65)`
    // do .video_render (feito para o título branco ler sobre foto) o deixava cinza. O cliente pediu
    // o banner como ele é. Allowlist: nos demais sites o banner segue escurecido.
    const BANNER_SEM_ESCURECER = new Set([2639]);
    const estiloBanner = BANNER_SEM_ESCURECER.has(Number(site?.id)) ? { filter: 'none' } : undefined;
    // cs2639 CASAMAIS+ (23/09/2026): a frase do banner de listagem vem DENTRO da imagem (3840×400) e no celular o
    // object-fit: cover recorta o centro — a frase saía cortada nas bordas. Só no celular (CSS ≤768px) e só aqui, a
    // imagem dá lugar ao título da home (frase_busca, o mesmo HTML do H1 do hero 2), centralizado e quebrando linha.
    // Desktop inalterado.
    const TITULO_DA_HOME_NO_CELULAR = new Set([2639]);
    const tituloBannerCelular = urlBanner && TITULO_DA_HOME_NO_CELULAR.has(Number(site?.id)) ? site?.frase_busca : undefined;
    const [vips, setVips] = useState<any>("");

    useEffect(() => {
        if(!vips){
            const vip: any = localStorage.getItem('vip');
            if(vip){
                setVips(vip)
            }
        }
    }, [vips]);

    return (

        <div className={`${styles.oneStep}${tituloBannerCelular ? ' ' + styles.comTituloNoCelular : ''}`} data-sem-banner={semBannerPadrao && !urlBanner ? '' : undefined} data-welcome={metropole ? 'metropole' : undefined}>
            <DrawerComponent
                site={site}
                activeDrawer={activeDrawer}
                setActiveDrawer={setActiveDrawer}
                favorito={favorito?.length > 0 ? favorito : []}
                vips={vips}
                menus={props?.menus}
            />
            {TopoNovo ?
                <div className={`${styles.header_welcome}${topoCompacto ? ' ' + styles.header_compact : ''}`} style={{padding: 0}}>
                    <TopoNovo site={site} setActiveDrawer={setActiveDrawer} setBuscaAvancada={null}/>
                </div>
            : site?.modelo_topo == 4 ?
                <div className={`${styles.header_welcome}${topoCompacto ? ' ' + styles.header_compact : ''}`}>
                    <TopoRegioes
                        site={site}
                        setActiveDrawer={setActiveDrawer}
                    />
                    <label className={styles.title}>{titulo}</label>
                </div>
            : site?.modelo_topo == 3 ?
                <div className={`${styles.header_welcome}${topoCompacto ? ' ' + styles.header_compact : ''}`} style={{padding: 0}}>
                    <Topo2 site={site} setActiveDrawer={setActiveDrawer} setBuscaAvancada={null}/>
                </div>
            :
                <div className={`${styles.header_welcome}${topoCompacto ? ' ' + styles.header_compact : ''}`}>
                    <Topo
                        site={site}
                        setActiveDrawer={setActiveDrawer}
                    />
                    <label className={styles.title}>{titulo}</label>
                </div>
            }
            
            {urlBanner || site?.id == "1609" ? (
                <Image
                    src={urlBanner}
                    alt="Banner"
                    className={styles.video_render}
                    style={estiloBanner}
                    width={1920}
                    height={540}
                    sizes="100vw"
                />
            ) : urlBanner == false ? (
                <Image
                    src={"https://fotos.sobressai.com.br/Banner/1722/10526.jpg"}
                    alt="Banner"
                    className={styles.video_render}
                    width={1920}
                    height={540}
                    sizes="100vw"
                />
            ) : null}
            {tituloBannerCelular ? (
                <p
                    className={styles.tituloBannerCelular}
                    style={{ color: site?.cor2 }}
                    dangerouslySetInnerHTML={{ __html: tituloBannerCelular }}
                />
            ) : null}
            {routes ? <HistoryComponent site={site} routes={routes} rotulos={rotulos}/> : null}
        </div>
    );
};
export default WelcomePiecesCompany;

